import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from ".";
import { Notification } from "../generated/graphql";

interface NotificationsState {
  loading: boolean;
  notifications: Array<Notification>;
}

const initialState: NotificationsState = {
  loading: true,
  notifications: [],
};

export const notificationSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    loading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setNotifications: (state, action: PayloadAction<Array<Notification>>) => {
      state.loading = false;
      state.notifications = [...state.notifications, ...action.payload];
    },
    reset: (state) => {
      state.loading = false;
      state.notifications = [];
    },
  },
});

export const { loading, reset, setNotifications } = notificationSlice.actions;

export const notificationSelector = (state: RootState) => state.meternumbers;

export default notificationSlice.reducer;
